import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TEXT } from 'locales/metaPageTitle';
import { useRouteData } from 'components/Application/RouteDataProvider/RouteDataProvider';

const basePageTitle = 'Balloon';

export const usePageTitle = (title) => {
  useEffect(() => {
    if (title === undefined || title === null) {
      return;
    }
    document.title = [title, basePageTitle].join(' | ');
  }, [title]);

  return (title) => {
    document.title = [title, basePageTitle].join(' | ');
  };
};

export const PageTitleContainer = () => {
  const { pathname } = useLocation();
  const { currentRoute } = useRouteData();

  useEffect(() => {
    const routeKey = currentRoute?.key;
    if (!routeKey || !TEXT.meta.pageTitle[routeKey]) {
      document.title = `${TEXT.meta.pageTitle.home} | ${basePageTitle}`;
      return;
    }
    document.title = [TEXT.meta.pageTitle[routeKey], basePageTitle].join(' | ');
  }, [pathname, currentRoute]);

  return null;
};
